import React, { useEffect, useLayoutEffect, useState } from "react";
import { IMAGE_BASE_URL, PUSHER_APP_KEY, SETTING } from "./constants/api";
import Base from "./component/inc/Base";
import { ConfigProvider, Spin, Watermark } from "antd";
import { displayMessage, getAPI } from "./utils/common";
import LS_SERVICE from "./utils/localStorage";
import { ERROR_MSG_TYPE } from "./constants/messages";
import {
  CREATOR_NAME,
  DEMO_MODE,
  PUSHER_APP_CLUSTER,
  SECONDARY_THEME,
  THEME,
} from "./constants/constent";
import Pusher from "pusher-js";
import {
  NotificationProvider,
  useNotification,
} from "./component/notification/NotificationContext";
import NotificationModal from "./component/notification/NotificationModal";
import { AppPageProvider } from "./context/AppPageContext";

const App = () => {
  const [loading, setIsLoading] = useState(true);
  const { setNotification } = useNotification();
  const { theme } = LS_SERVICE.get("setting") || {};

  // useEffect(() => {
  //   // Block Print Screen key
  //   const handleKeyUp = (e) => {
  //     if (e.key === "PrintScreen") {
  //       navigator.clipboard.writeText("");
  //       alert("Screenshots are disabled on this page.");
  //     }
  //   };

  //   document.addEventListener("keyup", handleKeyUp);

  //   // Detect DevTools
  //   const devToolsCheck = setInterval(function () {
  //     const devtools = /./;
  //     devtools.toString = function () {
  //       this.opened = true;
  //     };
  //     console.log("%c", devtools);
  //     if (devtools.opened) {
  //       alert("Dev tools are open. This page is protected.");
  //       window.location.reload(); // or redirect
  //     }
  //   }, 1000);

  //   // Cleanup listeners on unmount
  //   return () => {
  //     document.removeEventListener("keyup", handleKeyUp);
  //     clearInterval(devToolsCheck);
  //   };
  // }, []);

  useEffect(() => {
    const userId = LS_SERVICE.get("id");
    const userType = LS_SERVICE.get("user_type");

    // Check if we are on the "reservation" page
    const isReservationPage =
      window.location.pathname.startsWith("/reservation");

    if (userId && userType && userType !== "customer" && !isReservationPage) {
      // Initialize Pusher
      Pusher.logToConsole = true;
      const pusher = new Pusher(PUSHER_APP_KEY, {
        cluster: PUSHER_APP_CLUSTER,
        forceTLS: true,
      });

      // Subscribe to the notifications channel
      const channel = pusher.subscribe("my-channel");

      // Listen for the new notification event
      channel.bind("my-event", function (data) {
        console.log("Received notification data:", data);
        setNotification(data);
      });

      return () => {
        channel.unbind_all(); // Important to clean up properly
        pusher.unsubscribe("my-channel");
        pusher.disconnect(); // Disconnect on unmount
      };
    }
  }, [setNotification]);

  const getSetting = async () => {
    try {
      const successFn = (data) => {
        if (data.status === true) {
          const settings = {
            logo: data.data.company_logo.filePath || null,
            favicon: data.data.company_favicon.filePath || null,
            company_name: data.data.company_name || null,
            company_address: data.data.company_address || null,
            company_email: data.data.company_email || null,
            company_description: data.data.company_description || null,
            company_phone: data.data.company_phone || null,
            website: data.data.website || "",
            hnxt_hotel_id: data.data.hnxt_hotel_id || "",
            video_link: data.data.video_link || null,
            theme: data.data.theme || THEME,
          };

          LS_SERVICE.set("setting", settings);
          const { theme } = LS_SERVICE.get("setting") || {};
          document.documentElement.style.setProperty(
            "--primary-color",
            "#" + theme
          );
          document.documentElement.style.setProperty(
            "--secondary-color",
            "#" + SECONDARY_THEME
          );

          if (settings.favicon) {
            const link = document.querySelector("link[rel*='icon']");
            if (link) {
              link.href = IMAGE_BASE_URL + settings.favicon;
            } else {
              const newLink = document.createElement("link");
              newLink.rel = "icon";
              newLink.href = IMAGE_BASE_URL + settings.favicon;
              document.head.appendChild(newLink);
            }
          }

          if (settings.company_name) {
            document.title = settings.company_name;
          }

          if (settings.company_description) {
            const metaDescription = document.querySelector(
              "meta[name='description']"
            );
            if (metaDescription) {
              metaDescription.content = settings.company_description;
            } else {
              const newMetaDescription = document.createElement("meta");
              newMetaDescription.name = "description";
              newMetaDescription.content = settings.company_description;
              document.head.appendChild(newMetaDescription);
            }
          }
        } else {
          displayMessage(
            ERROR_MSG_TYPE,
            data.message || "Failed to load settings"
          );
        }
      };

      const errorFn = () => {
        displayMessage(ERROR_MSG_TYPE, "Unable to get settings");
      };

      await getAPI(SETTING, successFn, errorFn);
    } catch (error) {
      displayMessage(
        ERROR_MSG_TYPE,
        "An error occurred while loading settings."
      );
    }
  };

  useLayoutEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      await getSetting();
      setIsLoading(false);
    };
    loadData();
  }, []);

  if (loading) {
    return <Spin />;
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#" + theme,
          fontFamily: "Poppins, sans-serif",
        },
        components: {
          Button: {
            colorPrimary: "#" + theme,
          },
        },
      }}
    >
      <Base />
    </ConfigProvider>
  );
};
// Wrap your App component with the NotificationProvider to share state globally
const WrappedApp = () => (
  <NotificationProvider>
    {DEMO_MODE ? (
      <Watermark content={CREATOR_NAME}>
        <AppPageProvider>
          <App />
        </AppPageProvider>
      </Watermark>
    ) : (
      <AppPageProvider>
        <App />
      </AppPageProvider>
    )}
    <NotificationModal /> {/* Modal will display the notification */}
  </NotificationProvider>
);

export default WrappedApp;
